import { axiosGroup } from "./axiosGroup";

export interface UserData {
  id: string;
  user: {
    uid: string;
    userName: string;
  };
  email: string;
  verifiedStatus: {
    email: boolean;
    kyc: boolean;
  };
  questionare: boolean;
  reward: string;
  dateCreate?: number;
  isPublicProfile?: boolean;
  rawData?: any;
}

export interface PaginationData {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface GetUsersResponse {
  success: boolean;
  message: string;
  data: UserData[];
  pagination: PaginationData;
}

export interface GetUsersParams {
  search?: string;
  status?: "active" | "verified" | "email_verified" | "kyc_verified" | "unverified";
  sort?: string; // sort pattern: field = asc, -field = desc, comma-separated
  page?: number;
  limit?: number;
  questionnaire?: boolean;
}

export const getUsersAPI = async (params: GetUsersParams = {}): Promise<GetUsersResponse> => {
  const queryParams = new URLSearchParams();
  
  if (params.search) {
    queryParams.append("search", params.search);
  }
  
  if (params.status) {
    queryParams.append("status", params.status);
  }
  
  if (params.sort) {
    queryParams.append("sort", params.sort);
  }
  
  if (params.page) {
    queryParams.append("page", params.page.toString());
  }
  
  if (params.limit) {
    queryParams.append("limit", params.limit.toString());
  }

  if (params.questionnaire !== undefined) {
    queryParams.append("questionnaire", String(params.questionnaire));
  }

  const response = await axiosGroup.axiosServerAPI.get<GetUsersResponse>(
    `v2/users?${queryParams.toString()}`
  );

  return response.data;
};

export interface UpdateUserPayload {
  isPublicProfile?: boolean;
  availability?: boolean;
}

export interface UpdateUserResponse {
  success: boolean;
  message: string;
  data: { uid: string; isPublicProfile?: boolean; availability?: boolean };
}

export const updateUserAPI = async (
  uid: string,
  payload: UpdateUserPayload
): Promise<UpdateUserResponse> => {
  const response = await axiosGroup.axiosServerAPI.patch<UpdateUserResponse>(
    `v2/users/${uid}`,
    payload
  );
  return response.data;
};
